import style from '@/less/main.less';
import { useStores } from '@/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import Bulletin from '../Bulletin';

interface TriggerFirstOnboardingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TriggerFirstOnboardingModal = ({
  isOpen,
  onClose,
}: TriggerFirstOnboardingModalProps) => {
  const { userStore } = useStores();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal
      className={style.modal}
      open={isOpen}
      size="tiny"
      closeIcon={<Icon name="close" size="tiny" color="black" />}
      closeOnDimmerClick={false}
      onClose={onClose}
    >
      <Modal.Header>Are You Sure?</Modal.Header>

      <Modal.Content>
        <Bulletin
          errorMessage={userStore.errorMessage}
          isLoading={userStore.isLoading}
          handleDismiss={() => {
            userStore.clearError();
          }}
        />

        <Modal.Description style={{ marginBottom: 18 }}>
          Are you sure you want to trigger the first onboarding for all employees? This will send an
          email to all employees who have not started onboarding yet.
        </Modal.Description>
      </Modal.Content>

      <Modal.Actions>
        <Button color="grey" basic style={{ fontSize: '0.9rem' }} onClick={onClose}>
          Cancel
        </Button>
        <Button
          color="green"
          style={{ fontSize: '0.9rem' }}
          onClick={async () => {
            setIsLoading(true);

            await userStore.triggerFirstOnboarding();

            setIsLoading(false);
            onClose();
          }}
        >
          <FontAwesomeIcon
            icon={isLoading ? ['fas', 'spinner'] : ['fas', 'envelope']}
            style={{ marginRight: 8 }}
          />
          {isLoading ? 'Loading...' : 'Trigger First Onboarding'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
